<template>
  <section class="search-summary-bar" :class="{ desktop: $isDesktop }">
    <search-summary-bar-action
      v-if="searchReferrerRoute"
      :search-referrer-route="searchReferrerRoute"
      :has-dates="hasDates"
      :pts-viewed="ptsViewed"
    />
    <search-summary-bar-details
      :search-filters="searchFilters"
      :class="{ 'show-summary-bar-action': searchReferrerRoute !== null }"
      :slug="campsiteSlug"
    />
  </section>
</template>

<script lang="ts">
import { Route } from '../../../apps/pu-links/domain/Route'
import type { SearchFilters } from '../../../apps/search/schemas'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { SearchSummaryBarProps } from './SearchSummaryBarProps'

@Component
class SearchSummaryBar extends Vue implements SearchSummaryBarProps {
  @Prop()
  searchFilters: SearchFilters

  @Prop({ default: null })
  searchReferrerRoute: Route | null

  @Prop({ required: false })
  campsiteSlug?: string

  @Prop({ required: false })
  ptsViewed: number

  get hasDates() {
    const dates = this.searchFilters.dates

    if (!dates || (!dates.arrive && !dates.depart)) {
      return
    }
    return true
  }
}

export default toNative(SearchSummaryBar)
</script>
<style scoped>
.search-summary-bar {
  align-items: center;
  background: white;
  border-top: 1px solid #dedede;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  height: 13vw;
  justify-content: flex-start;
  width: 100vw;
}

/* mobile landscape */
@media screen and (min-width: 320px) and (max-width: 998px) and (orientation: landscape) {
  .search-summary-bar {
    height: 2.5em;
  }
}

/* desktop & tablet */
.search-summary-bar.desktop {
  height: auto;
  width: auto;
  border: none;
  background: #e4e8ec;
  padding: 0.5em 1em;
}
</style>
